import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  SaveButton,
  FormRow
} from '../../../components'

const FormEmail = () => {
  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <FormRow>
        <Label>New Email Address</Label>
        <Input className="w-full" type="email"/>
      </FormRow>
      <FormRow last>
        <Label>Your Current Password</Label>
        <Input className="w-full" type="password"/>
      </FormRow>
      <SaveButton />
    </form>
  )
}

export { FormEmail }